import React from "react";
import { Flex, Spinner } from "@chakra-ui/react";
import { Navigate } from "react-router-dom";
import { useUser } from "../contexts/UserContext";

export default function NonManagerRoute({ children }) {
  const { loading, isAdmin, userInfo } = useUser();

  if (loading) {
    return (
      <Flex minH="100vh" align="center" justify="center" bg="gray.50">
        <Spinner size="xl" color="blue.500" />
      </Flex>
    );
  }

  if (!isAdmin && userInfo?.role === "manager") {
    return <Navigate to="/manager/engagement" replace />;
  }

  return children;
}
